import { render, staticRenderFns } from "./RuleConfigModify.vue?vue&type=template&id=fa08732c&scoped=true&"
import script from "./RuleConfigModify.vue?vue&type=script&lang=js&"
export * from "./RuleConfigModify.vue?vue&type=script&lang=js&"
import style0 from "./RuleConfigModify.vue?vue&type=style&index=0&id=fa08732c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa08732c",
  null
  
)

export default component.exports